<div class="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700">
  <div class="relative overflow-hidden">
      <a [routerLink]="['/vestiging']" [queryParams]="{vestiging: vestiging.id}" routerLinkActive="router-link-active">
        <img [src]="vestiging.foto" class="scale-110 group-hover:scale-100 transition-all duration-500" alt="">
      </a>
  </div>

  <div class="relative p-6">
    <a [routerLink]="['/vestiging']" [queryParams]="{vestiging: vestiging.id}" routerLinkActive="router-link-active">
      <div class="absolute left-6 -top-4">
          <span class="bg-earth-try text-black/70 text-[12px] px-2.5 py-1 font-semibold rounded-full h-5">{{ vestiging.naam }}</span>
      </div>
    </a>

    <div class="">
      <div class="flex mb-2" *ngIf="details">
        <span class="text-slate-400 text-sm"><div class="spacers icon"><i class="uil uil-map-marker text-slate-900 dark:text-white mr-2"></i><br />&nbsp;</div><div class="spacers">{{ vestiging.straat + ' ' + vestiging.huisnummer}}<br />{{ vestiging.gemeente}}</div></span>
      </div>

      <div class="flex" [ngClass]="{'mb-2': details, '-mb-2': !details}">
        <span class="text-slate-400 text-sm"><div class="spacers icon"><i class="uil uil-envelope text-slate-900 dark:text-white mr-2"></i></div><div class="spacers"><a [href]="'mailto:'+vestiging.email">{{ vestiging.email }}</a></div></span>
      </div>

      <div class="flex mb-2" *ngIf="details">
        <span class="text-slate-400 text-sm"><div class="spacers icon"><i class="uil uil-phone text-slate-900 dark:text-white mr-2"></i></div><div class="spacers"><a [href]="'mailto:'+vestiging.email">{{ vestiging.telefoon }}</a></div></span>
      </div>
    </div>
  </div>
</div>
